import Nav from "./nav"
import Search from "./search"
import Form from "./form"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    Form(jQuery)
})
